export default "__VITE_ASSET__Dvvkq8QS__"